<template>
  <div class="help-center-post-wall__component">
    <h1 class="help-center-post-wall__title">
      {{ title }}
    </h1>
    <div class="help-center-post-wall__tiles">
      <HelpCenterPostWallTile
        v-for="entry of entries"
        :key="entry.post.url"
        :post="entry.post"
        :loading="entry.loading"
        :author-map="authorMap"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterPostWallTile from 'help-center/components/HelpCenterPostWallTile'

const props = defineProps({
  postMap: {
    type: Object,
    required: true
  },
  authorMap: {
    type: Object,
    required: true
  },
  defaultPosts: {
    type: Array,
    required: true
  },
  selectedTab: {
    type: Object,
    required: true
  },
  selectedCategory: Object
})

const title = computed(() => {
  return props.selectedCategory?.title ?? props.selectedTab.title
})

const entries = computed(() => {
  const postUrls = props.selectedCategory
    ? props.selectedCategory.posts
    : props.defaultPosts

  return postUrls.map((postUrl, index) => {
    return {
      post: props.postMap[postUrl],
      loading: index === 0 ? 'eager' : 'lazy'
    }
  })
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-wall {
  &__component {
    gap: 12px;
    display: flex;
    flex-direction: column;

    @include help-center-breakpoint(md) {
      gap: 28px;
    }
  }

  &__title {
    @include help-center-font(24, title);
    color: var(--help-center-accent);
    font-weight: var(--help-center-bold);

    @include help-center-breakpoint(md) {
      @include help-center-font(28, title);
    }
  }

  &__tiles {
    gap: 16px;
    display: grid;
    align-items: stretch;
    grid-template-columns: 1fr;

    @include help-center-breakpoint(sm) {
      grid-template-columns: 1fr 1fr;
    }

    @include help-center-breakpoint(md) {
      gap: 20px;
    }

    @include help-center-breakpoint(lg) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
}
</style>
